import { render, staticRenderFns } from "./BookForm.vue?vue&type=template&id=4e6f1fee&scoped=true&"
import script from "./BookForm.vue?vue&type=script&lang=js&"
export * from "./BookForm.vue?vue&type=script&lang=js&"
import style0 from "./BookForm.vue?vue&type=style&index=0&id=4e6f1fee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6f1fee",
  null
  
)

export default component.exports